// extracted by mini-css-extract-plugin
export default {"regular":"CheckBox_regular__sJ6Hn"};